"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuoteCurrencyFormatter = void 0;
var react_1 = require("react");
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var useQuoteCurrencyFormatter = function () {
    return (0, react_1.useMemo)(function () {
        var format = function (value) {
            return (0, FormatCurrency_1.formatCurrency)(value, "AUD", 2);
        };
        var parse = function (value) {
            return (0, FormatCurrency_1.parseCurrency)(value, "AUD");
        };
        var currencySymbol = "$";
        return { format: format, parse: parse, currencySymbol: currencySymbol };
    }, []);
};
exports.useQuoteCurrencyFormatter = useQuoteCurrencyFormatter;
